import ApiClient from "../api/apiClient";

const NOTIFICATION = "/notification";
const ENDORSEIDDETAIL = "/certificates/applicants-by-user"
const ENDORSEMENTSTATUS = "/endorsements/status"

const getAllNotifications = (page = 1, limit = 10) => {
    return ApiClient.get(NOTIFICATION, {
        params: {
            page,
            limit
        }
    });
};

const updateEndorsementStatus = (data) => {
    const url = ENDORSEMENTSTATUS;
    return ApiClient.put(url, data);
}

const getEndorsementIdDetail = (id) => {
    return ApiClient.get(ENDORSEIDDETAIL + '/' + id)
};

export const notificationService = {
    getAllNotifications,
    getEndorsementIdDetail,
    updateEndorsementStatus,
};
